import httpStatus from 'http-status';
import { FetchUtils } from '~/utils/fetch-utils';

interface ProcedureApiParams {
	formSubtype?: string;
}

export class ProcedureApi {
	public static getProcedureFile(
		formName: string,
		formSubtype: string | undefined,
	): Promise<any> {
		return FetchUtils.get('api/procedures/:formName/:formSubtype', {
			formName,
			formSubtype,
		}).then((data) => {
			const contentType: string = data.headers.get('Content-Type');
			if (!contentType) {
				throw new Error(
					'Failed to get Content Type from Procedure File API response',
				);
			}

			if (
				data.status === httpStatus.MULTIPLE_CHOICES &&
				contentType.includes('text/plain')
			) {
				return data.text();
			} else if (
				data.status === httpStatus.NOT_FOUND &&
				contentType.includes('application/json')
			) {
				return data.json();
			}

			let errorMessage =
				'Failed to get Procedure File path from API response.';
			if (data.status) {
				errorMessage += ' Unhandled status: ' + data.status + '.';
			}
			if (data.statusText) {
				errorMessage += ' Reason: ' + data.statusText + '.';
			}
			throw new Error(errorMessage);
		});
	}
}
